<mat-accordion [togglePosition]="'before'" [multi]="true">
  <mat-expansion-panel
    (opened)="expansionPanelEventOpen('team')"
    (closed)="expansionPanelEventClose('team')"
    [expanded]="team"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 matSubheader>{{ 'common.teams' | t }}</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngIf]="teamChannels.length">
      <sn-channel-list
        [items]="teamChannels"
        [activatedItem]="activeChannel"
        (itemTap)="onChannelSelected($event)"
      >
      </sn-channel-list>
    </ng-template>
  </mat-expansion-panel>
  <mat-expansion-panel
    (opened)="expansionPanelEventOpen('sharedChannels')"
    (closed)="expansionPanelEventClose('sharedChannels')"
    [expanded]="channel"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 matSubheader class="position-relative">
          <span>{{ 'navigation.sharedChannels' | t }}</span>
          <sn-icon
            class="add-button"
            *ngIf="canAdd"
            fontSet="fal"
            fontIcon="fa-plus-circle"
            (click)="addOrganizationChannel();$event.stopPropagation()"
          ></sn-icon>
        </h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngIf]="isLoading">
      <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent" class="spinner"></mat-spinner>
    </ng-template>
    <ng-template [ngIf]="sharedChannels.length && !isLoading">
      <sn-channel-list
        [items]="sharedChannels"
        [activatedItem]="activeChannel"
        (itemTap)="onChannelSelected($event)"
      >
      </sn-channel-list>
    </ng-template>
  </mat-expansion-panel>
  <mat-expansion-panel
    (opened)="expansionPanelEventOpen('channels')"
    (closed)="expansionPanelEventClose('channels')"
    [expanded]="channel"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 matSubheader class="position-relative">
          <span>{{ 'common.channels' | t }}</span>
          <sn-icon
            class="add-button"
            *ngIf="canAdd"
            fontSet="fal"
            fontIcon="fa-plus-circle"
            (click)="addOrganizationChannel();$event.stopPropagation()"
          ></sn-icon>
        </h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngIf]="isLoading">
      <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent" class="spinner"></mat-spinner>
    </ng-template>
    <ng-template [ngIf]="organizationChannels.length && !isLoading">
      <sn-channel-list
        [items]="organizationChannels"
        [activatedItem]="activeChannel"
        (itemTap)="onChannelSelected($event)"
      >
      </sn-channel-list>
    </ng-template>
  </mat-expansion-panel>
  <mat-expansion-panel
    (opened)="expansionPanelEventOpen('direct')"
    (closed)="expansionPanelEventClose('direct')"
    [expanded]="direct"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3 matSubheader class="position-relative">
          <span>{{ 'common.directMessages' | t }}</span>
          <sn-icon
            class="add-button"
            *ngIf="canAdd"
            fontSet="fal"
            fontIcon="fa-plus-circle"
            (click)="addDirectChannel();$event.stopPropagation()"
          ></sn-icon>
        </h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngIf]="directChannels.length">
      <sn-channel-list
        [items]="directChannels"
        [activatedItem]="activeChannel"
        (itemTap)="onChannelSelected($event)"
      >
      </sn-channel-list>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
